import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { Text, TextProps, addWithConfig } from '@fhs-legacy/universal-components';

import { StyledRewardPointCost } from './reward-point-cost.styled';

export interface IRewardPointCost extends TextProps {
  pointCost: number;
  usePrimaryColor?: boolean;
}

const RewardPointCostText: FC<React.PropsWithChildren<IRewardPointCost>> = ({
  pointCost,
  usePrimaryColor,
  children,
  ...textProps
}) => {
  const { formatMessage } = useIntl();

  return pointCost === 0 ? (
    <StyledRewardPointCost usePrimaryColor={usePrimaryColor} {...textProps}>
      {formatMessage({ id: 'free' }).toLocaleLowerCase()}
    </StyledRewardPointCost>
  ) : (
    <Text {...textProps}>{children}</Text>
  );
};

export const RewardPointCost = addWithConfig(RewardPointCostText);
